export const sharedHeadCells = [
	{ id: 'name', label: 'Client name', sortable: true },
	{ id: 'contactName', label: 'Contact name', sortable: true },
	{ id: 'ownerDocId', label: 'Client owner', sortable: true },
	{ id: 'contactEmail', label: 'Email', sortable: true },
	{ id: 'contactPhone', label: 'Phone', sortable: true },
	{ id: 'brokerGroupId', label: 'Broker group', sortable: false },
	{ id: 'createdDate', label: 'Created date', sortable: true },
];

export const clientHeadCells = [{ id: 'insightId', label: 'ID', sortable: true }];

export const prospectHeadCells = [
	{ id: 'stage', label: 'Stage', sortable: true },
	{ id: 'prospectAmount', label: 'Prospect amount', sortable: true },
	{ id: 'nextTaskDate', label: 'Next task date', sortable: true },
	{ id: 'lossReason', label: 'Loss reason', sortable: false },
];
